import { Link } from 'react-router-dom';
import { getFeaturedMovies, type MovieItem } from '@/mocks/movies';

function MovieCard({ movie }: { movie: MovieItem }) {
  const imageUrls: Record<string, string> = {
    'movie-cover-01': 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20distant%20planets%2C%20dramatic%20orange%20and%20deep%20blue%20cosmic%20lighting%2C%20epic%20scale%2C%20clean%20minimal%20composition%2C%20professional%20movie%20poster%20aesthetic%2C%20no%20text%2C%20dark%20atmospheric%20background&width=600&height=840&seq=movie-card-01&orientation=portrait',
    'movie-cover-02': 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20poetry%20animated%20film%20poster%20style%2C%20traditional%20ink%20wash%20painting%20aesthetic%20with%20warm%20golden%20and%20earth%20tones%2C%20elegant%20classical%20composition%2C%20Tang%20dynasty%20vibe%2C%20artistic%20soft%20lighting%2C%20no%20text%2C%20minimalist&width=600&height=840&seq=movie-card-02&orientation=portrait',
    'movie-cover-03': 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20fantasy%20film%20poster%2C%20ancient%20warriors%20in%20armor%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20grand%20battle%20atmosphere%2C%20cinematic%20epic%20scale%2C%20dark%20moody%20background%2C%20no%20text%2C%20professional%20poster%20style&width=600&height=840&seq=movie-card-03&orientation=portrait',
    'tv-cover-01': 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20elegant%20ancient%20costumes%20and%20palace%20interior%2C%20warm%20golden%20lantern%20light%2C%20royal%20court%20atmosphere%2C%20rich%20red%20and%20gold%20tones%2C%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=tv-card-01&orientation=portrait',
    'tv-cover-02': 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%2C%20modern%20Chinese%20police%20officer%20silhouette%20against%20city%20night%2C%20dark%20blue%20and%20red%20moody%20lighting%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=tv-card-02&orientation=portrait',
    'variety-cover-01': 'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20poster%20with%20running%20figures%20and%20playful%20energy%2C%20vibrant%20yellow%20and%20coral%20colors%2C%20dynamic%20action%20composition%2C%20fun%20lively%20atmosphere%2C%20game%20show%20vibe%2C%20no%20text&width=600&height=840&seq=variety-card-01&orientation=portrait',
    'anime-cover-01': 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20donghua%20poster%2C%20martial%20arts%20warrior%20with%20flowing%20robes%20in%20mountain%20landscape%2C%20ethereal%20mist%20and%20spiritual%20energy%2C%20cool%20blue%20and%20jade%20green%20tones%2C%20cinematic%20anime%20style%2C%20no%20text&width=600&height=840&seq=anime-card-01&orientation=portrait',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={imageUrls[movie.imageSeq] || imageUrls['movie-cover-01']}
          alt={movie.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-semibold rounded-md whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <p className="text-white text-xs leading-relaxed line-clamp-3">
            {movie.description}
          </p>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1 line-clamp-1">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{movie.region}</span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedContent() {
  const featured = getFeaturedMovies();

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">
              编辑精选的高分影视作品，每一部都值得观看
            </p>
          </div>
          <a
            href="/category/movie"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}